/**
 * Wraps an async function keyed by its first argument to deduplicate concurrent
 * calls for the same key. While a call is in-flight, subsequent calls with the
 * same key return the existing promise instead of starting a new one.
 */
export function deduplicateAsync<TKey, TResult>(fn: (key: TKey) => Promise<TResult>): (key: TKey) => Promise<TResult> {
  const inFlight = new Map<TKey, Promise<TResult>>()

  return (key: TKey): Promise<TResult> => {
    const existing = inFlight.get(key)
    if (existing) return existing

    const promise = fn(key).finally(() => inFlight.delete(key))
    inFlight.set(key, promise)
    return promise
  }
}
